var _defs, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrenchFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#283890;}.b{fill:#fafafa;}.c{fill:#ef4236;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283890",
    d: "M236.189,824.108a2.212,2.212,0,0,0-2.264,2.157v12.687a2.212,2.212,0,0,0,2.264,2.157h6.576v-17Z",
    transform: "translate(-233.925 -824.108)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.525 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fafafa",
    width: 8.95,
    height: 17,
    transform: "translate(0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ef4236",
    d: "M374.109,824.108h-6.576v17h6.576a2.212,2.212,0,0,0,2.264-2.157V826.265A2.212,2.212,0,0,0,374.109,824.108Z",
    transform: "translate(-367.533 -824.108)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrenchFlag);
export default __webpack_public_path__ + "static/media/frenchFlag.f5e343e52c15069422ff50cb1203c9d0.svg";
export { ForwardRef as ReactComponent };